import {Record} from 'immutable';

const Status = Record({
    icon: null,
    title: null,
    color: null,
    statusConfigId: null,
    deleting: false,
    loading: false,
});

export const fromAPI = status => new Status(status);

export default {
    record: Status,
    fromAPI,
};
